export default {
  // Default export is a Vue plugin
  install (Vue) {
    // Read more about instance properties on https://vuejs.org/v2/cookbook/adding-instance-properties.html#Base-Example
    Vue.prototype['$link'] = {
      slugify (string) {
        if (!string) return
        let slug = string

        const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
        const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
        const p = new RegExp(a.split('').join('|'), 'g')

        return slug.toString().toLowerCase()
          .replace(/\s+/g, '-') // Replace spaces with -
          .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
          .replace(/&/g, '-en-') // Replace & with 'and'
          .replace(/[^\w\-]+/g, '') // Remove all non-word characters
          .replace(/\-\-+/g, '-') // Replace multiple - with single -
          .replace(/^-+/, '') // Trim - from start of text
          .replace(/-+$/, '') // Trim - from end of text
      },
      publication (p) {
        const {
          prepr: {
            environments,
            models,
          },
          preprEnvironment: currentEnvironmentSlug,
        } = Vue.prototype.$library
  
        // Check for mandatory configs
        if (!environments || !p) {
          return
        }
  
        // get constants from publication
        const {
          url: externalUrl,
          reference: referencePublication, // overwrite teaser with referenced publications
        } = p
  
        // Check if a direct url link is available
        if (externalUrl) {
          return externalUrl
        }
  
        const getEnvironmentBySlug = ( slug ) => {
          const [, matchingEnvironment] = Object.entries(environments).find(([, env]) => env && env.slug === slug)
          return matchingEnvironment
        }
  
        // Check if publication is a teaser/cta and contains an other publication
        if (referencePublication) {
          p = referencePublication
        }
  
        // Get constants from publication
        const {
          id,
          slug,
          items: {
            'nl-NL': {
              prepr_environment_id: {
                body: directEnvironmentId,
              } = {},
            } = {},
          } = {},
        } = p
  
        const publicationSlug = slug?.['nl-NL'] || slug
  
        // Get possible values (that can be overwritten) from publication
        let {
          community: {
            environmentId: communityEnvironmentId,
          } = {},
          environmentId,
          environmentDomain: environmentSlug,
          modelId,
        } = p
  
        // for the unmapped publications
        if (!environmentId) {
          environmentId = p.environment?.id
        }
        if (!modelId) {
          modelId = p.model?.id || p.model_id
        }
        if (!communityEnvironmentId) {
          communityEnvironmentId = p?.items?.['nl-NL']?.community?.items?.[0]?.items?.['nl-NL']?.prepr_environment_id?.body
        }
  
        const modelName = models[modelId]?.name
  
        // redirect communities directly to the environment
        if (modelName === 'community' && directEnvironmentId) {
          const { baseUrl: directUrl } = environments[directEnvironmentId]
          if (directUrl) {
            return directUrl
          }
        }
  
        // overwrite environment-id when community is connected (but current environment isn't over/www.eo.nl). (this replaces `generieke-content-eo` with a specific environment like `lazarus-eo`)
        if (communityEnvironmentId && currentEnvironmentSlug !== 'corporate-eo' && currentEnvironmentSlug !== 'home-eo') {
          environmentId = communityEnvironmentId
        }
  
        // get environment vars
        let environment = environmentId && environments[environmentId]
  
        // if environment is still unknown, try to get it with a environment-domain/slug instead of an environment-id
        environmentSlug = environment?.slug || environmentSlug || p.environment?.domain || p.environment_domain || currentEnvironmentSlug
  
        // redirect all presenters to EO Home (except for EO Corporate)
        if (modelName === 'person' && currentEnvironmentSlug !== 'corporate-eo') {
          const roles = p.items?.['nl-NL']?.role?.items
          // if only role is being a presenter, redirect to EO Home
          if (roles && roles.length === 1 && roles[0]?.slug === 'presentator') {
            environmentSlug = 'home-eo'
          }
        }
        
        // get different environment when publication comes from 'generieke-content'
        // redirect podcasts to EO Home, when there is no community connected
        if (environmentSlug === 'generieke-content-eo') {
          environmentSlug = 'home-eo'
          environment = null

          if (currentEnvironmentSlug === 'corporate-eo' && modelName !== 'podcast') {
            environmentSlug = 'corporate-eo'
          }
        }
  
        // if environment still not exist, but environment-slug is known, then try again
        if (!environment && environmentSlug) {
          environment = getEnvironmentBySlug(environmentSlug)
        }

        environmentSlug = environment?.slug
        const { baseUrl } = environment
  
        // generate query string for other environment to dissolve
        const searchParams = new URLSearchParams({
          ...(id && { id }),
          ...(modelId && { 'model-id': modelId }),
          ...(publicationSlug && { slug: publicationSlug }),
          ...(environmentSlug && { 'environment-slug': environmentSlug }),
        }).toString()
  
        // create uri with search parameters
        const uri = `/publication?${searchParams}`
  
        // if something goed wrong, return uri
        if (!environmentSlug || !baseUrl) {
          return uri
        }

        // get current base url based on current environment slug
        const { baseUrl: currentBaseUrl } = currentEnvironmentSlug && getEnvironmentBySlug(currentEnvironmentSlug) || {}
  
        // don't add domain if the domain is equal to the current domain
        if (baseUrl === currentBaseUrl) {
          return uri
        }
  
        // return redirect route with query
        return baseUrl + uri
      },
    }
  },
}
